import { CSS_SELECTOR, useCustomCss } from '../../contexts/CustomCss';
import { FunctionalComponent, h } from 'preact';
import styled from 'styled-components';

const H1 = styled.div`
  border: 0;
  color: ${({ theme }) => theme.ui.text.color};
  font-size: ${({ theme }) => theme.typography.size.large};
  font-weight: ${({ theme }) => theme.typography.weight.bold};
  margin: 0;
`;

const Heading: FunctionalComponent = ({ children }) => {
  const { rules } = useCustomCss(CSS_SELECTOR.TITLE);

  return (
    <H1 role="heading" aria-level={1} style={{ ...rules }}>
      {children}
    </H1>
  );
};

export default Heading;
